const Report = () =>
  import(
    /* webpackChunkName: "financial-tariff-furniture-car" */ '@/pages/financial/tariff/furniture/car/index.vue'
  )

const Create = () =>
  import(
    /* webpackChunkName: "financial-tariff-furniture-car" */ '@/pages/financial/tariff/furniture/car/create.vue'
  )

const Edit = () =>
  import(
    /* webpackChunkName: "financial-tariff-furniture-car" */ '@/pages/financial/tariff/furniture/car/edit.vue'
  )

export default {
  name: 'FinancialFurnitureCarTariff',
  path: 'car',
  meta: {
    label: 'carTariff',
    auth: 'car'
  },
  component: {
    name: 'Car',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'FinancialFurnitureCarTariffReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report
    },
    {
      name: 'CreateFinancialFurnitureCarTariff',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'EditFinancialFurnitureCarTariff',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    }
  ]
}
